"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomLayoutSite = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
var LayoutSiteBase_1 = require("../LayoutSiteBase");
var DomLayoutSite = /** @class */ (function (_super) {
    __extends(DomLayoutSite, _super);
    /* istanbul ignore next */
    function DomLayoutSite(element) {
        var _this = _super.call(this) || this;
        _this._element = element;
        _this.updateAvailableSize({
            width: _this._element.clientWidth,
            height: _this._element.clientHeight,
        });
        _this._ro = new resize_observer_polyfill_1.default(function (entries) {
            _this.updateAvailableSize(entries[0].contentRect);
        });
        _this._ro.observe(_this._element);
        return _this;
    }
    /* istanbul ignore next */
    DomLayoutSite.prototype.dispose = function () {
        this._ro.disconnect();
        _super.prototype.dispose.call(this);
    };
    return DomLayoutSite;
}(LayoutSiteBase_1.LayoutSiteBase));
exports.DomLayoutSite = DomLayoutSite;
//# sourceMappingURL=DomLayoutSite.js.map